{
  "name": "fincura-customer-analyst-frontend",
  "version": "12.72.0",
  "license": "MIT",
  "angular-cli": {},
  "overrides": {
    "uuid": "^11.0.0"
  },
  "scripts": {
    "ng-clean": "rm -rf node_modules package-lock.json && npm install",
    "ng-dev": "./node_modules/.bin/ng serve",
    "ng-build-prod": "./node_modules/.bin/ng build --configuration production --aot",
    "start": "./node_modules/.bin/ng serve",
    "test": "./node_modules/.bin/ng test --progress --code-coverage --watch=false",
    "test-local": "./node_modules/.bin/ng test --progress --code-coverage",
    "lint": "./node_modules/.bin/ng lint",
    "generate-build-info": "node scripts/generate-build-info.js",
    "postinstall": "npm run generate-build-info",
    "prebuild": "npm run generate-build-info",
    "build": "NODE_OPTIONS=--max-old-space-size=8192 ./node_modules/.bin/ng build --progress",
    "storybook": "start-storybook -p 6006",
    "build-storybook": "build-storybook"
  },
  "engines": {
    "node": ">=24.0.0",
    "npm": ">=5.3.0",
    "yarn": ">=1.3.0 <2.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "^21.2.9",
    "@angular/animations": "^21.2.10",
    "@angular/cdk": "^21.2.9",
    "@angular/compiler": "^21.2.10",
    "@angular/core": "^21.2.10",
    "@angular/forms": "^21.2.10",
    "@angular/platform-browser": "^21.2.10",
    "@angular/platform-browser-dynamic": "^21.2.10",
    "@angular/platform-server": "^21.2.10",
    "@angular/router": "^21.2.10",
    "@ali-hm/angular-tree-component": "^21.0.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@datadog/browser-logs": "1.14.1",
    "@handsontable/angular": "^13.1.0",
    "@ng-select/ng-select": "^21.0.0",
    "@ngrx/router-store": "^21.1.0",
    "@ngrx/store": "^21.1.0",
    "@ngrx/store-devtools": "^21.1.0",
    "@segment/analytics-next": "^1.76.0",
    "@sentry/angular": "^10.27.0",
    "@types/file-saver": "^2.0.7",
    "@types/mousetrap": "1.6.2",
    "@types/pubnub": "^7.4.2",
    "ajv": "^8.17.1",
    "bootstrap": "^5.3.3",
    "d3": "^7.9.0",
    "file-saver": "^2.0.5",
    "gsap": "^3.12.5",
    "handsontable": "^13.1.0",
    "hotkeys-js": "^4.0.3",
    "launchdarkly-js-client-sdk": "^3.9.0",
    "mathjs": "^7.5.1",
    "moment": "2.29.4",
    "ngx-image-cropper": "^8.0.0",
    "ngx-mask": "^21.0.0",
    "ngx-moment": "^6.0.2",
    "ngx-pagination": "^6.0.3",
    "ngx-toastr": "^20.0.0",
    "pdf-lib": "^1.17.1",
    "pubnub": "7.6.1",
    "rxjs": "~7.8.0",
    "stacktrace-js": "2.0.2",
    "underscore": "1.13.6",
    "uuid": "^11.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/schematics": "^21.2.9",
    "@angular-eslint/builder": "^21.0.0",
    "@angular-eslint/eslint-plugin": "^21.0.0",
    "@angular-eslint/eslint-plugin-template": "^21.0.0",
    "@angular-eslint/schematics": "^21.0.0",
    "@angular-eslint/template-parser": "^21.0.0",
    "@angular/build": "^21.2.9",
    "@angular/cli": "^21.2.9",
    "@angular/common": "^21.2.10",
    "@angular/compiler-cli": "^21.2.10",
    "@angular/language-service": "^21.2.10",
    "@babel/core": "^7.26.0",
    "@ngrx/schematics": "^21.1.0",
    "@types/d3": "^7.4.3",
    "@types/jasmine": "~5.1.0",
    "@types/jquery": "^3.5.32",
    "@types/node": "^22.9.0",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^8.10.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^62.0.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^4.2.1",
    "jasmine-core": "~5.13.0",
    "jquery": "^3.7.1",
    "json-loader": "^0.5.7",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "karma-junit-reporter": "^2.0.1",
    "prettier": "^2.8.8",
    "raw-loader": "^0.5.1",
    "typescript": "^5.9.3",
    "uglify-js": "^3.19.3"
  }
}